import { useCallback } from "react";
import { Toast } from "@covertree/utils";
import { useRetryFailedRenewalOperationMutation } from "@covertree/agent-portal-graphql";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";
import { delayRefetchedQuery } from "@utils/delayRefetchedQuery";

export function useRetryFailedRenewal(shouldRefetchListAfterRetry = false) {
  const [retryFailedRenewal, { loading }] =
    useRetryFailedRenewalOperationMutation({
      refetchQueries: shouldRefetchListAfterRetry
        ? ["GetRenewalListItems"]
        : undefined,
      onQueryUpdated: shouldRefetchListAfterRetry
        ? delayRefetchedQuery
        : undefined,
    });

  const retryFailedRenewalHandler = useCallback(
    async (renewalLocator: string) => {
      try {
        await retryFailedRenewal({
          variables: {
            renewalLocator,
          },
        });

        Toast.showSuccess("Renewal operation retry succeeded.");
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ??
            "Could not retry renewal. Please try again"
        );
      }
    },
    [retryFailedRenewal]
  );

  return {
    retryFailedRenewal: retryFailedRenewalHandler,
    loading,
  };
}
